import React, { useState, useEffect } from 'react';
import cargos from '../../../../libs/cargos';

const ClienteForm = ({ cliente, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    razaoSocial: '',
    cnpj: '',
    nire: '',
    nomeFantasia: '',
    telefone: '',
    celularWhatsApp: '',
    emailRF: '',
    telefoneResponsavel: '',
    celularWhatsAppResponsavel: '',
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    pais: 'Brasil',
    nomeCompletoResponsavel: '',
    cargo: '',
    dataNascimento: '',
    nomeCompletoAssinanteDBE: '',
    cargoAssinanteDBE: '',
    dataNascimentoAssinanteDBE: '',
    email: '',
    password: '',
    confirmarSenha: '',
  });
  
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [cnpjSuggestion, setCnpjSuggestion] = useState(null);

  // States list for dropdown
  const estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 
    'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 
    'SP', 'SE', 'TO'
  ];

  useEffect(() => {
    // If we're editing, populate the form with the cliente data
    if (cliente) {
      setFormData({
        razaoSocial: cliente.razaoSocial || '',
        cnpj: cliente.cnpj || '',
        nire: cliente.nire || '',
        nomeFantasia: cliente.nomeFantasia || '',
        telefone: cliente.telefone || '',
        celularWhatsApp: cliente.celularWhatsApp || '',
        emailRF: cliente.emailRF || '',
        telefoneResponsavel: cliente.telefoneResponsavel || '',
        celularWhatsAppResponsavel: cliente.celularWhatsAppResponsavel || '',
        cep: cliente.cep || '',
        endereco: cliente.endereco || '',
        numero: cliente.numero || '',
        complemento: cliente.complemento || '',
        bairro: cliente.bairro || '',
        cidade: cliente.cidade || '',
        estado: cliente.estado || '',
        pais: cliente.pais || 'Brasil',
        nomeCompletoResponsavel: cliente.nomeCompletoResponsavel || '',
        cargo: cliente.cargo || '',
        dataNascimento: cliente.dataNascimento || '',
        nomeCompletoAssinanteDBE: cliente.nomeCompletoAssinanteDBE || '',
        cargoAssinanteDBE: cliente.cargoAssinanteDBE || '',
        dataNascimentoAssinanteDBE: cliente.dataNascimentoAssinanteDBE || '',
        email: cliente.email || '',
        password: '',
        confirmarSenha: '',
      });
    }
  }, [cliente]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error for this field when user types
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
    
    // Clear CNPJ suggestion if the field changes
    if (name === 'cnpj') {
      setCnpjSuggestion(null);
    }
  };

  // Format CNPJ as user types
  const handleCNPJChange = (e) => {
    const { value } = e.target;
    
    // Remove all non-digits
    let digits = value.replace(/\D/g, '');
    
    // Limit to 14 digits
    digits = digits.slice(0, 14);
    
    // Format with mask: XX.XXX.XXX/XXXX-XX
    let formatted = '';
    if (digits.length > 0) formatted += digits.slice(0, 2);
    if (digits.length > 2) formatted += '.' + digits.slice(2, 5);
    if (digits.length > 5) formatted += '.' + digits.slice(5, 8);
    if (digits.length > 8) formatted += '/' + digits.slice(8, 12);
    if (digits.length > 12) formatted += '-' + digits.slice(12, 14);
    
    // Update the form data
    setFormData(prev => ({
      ...prev,
      cnpj: formatted
    }));
    
    // Clear error for this field when user types
    if (errors.cnpj) {
      setErrors(prev => ({
        ...prev,
        cnpj: null
      }));
    }
    
    // Clear any existing suggestion
    setCnpjSuggestion(null);
  };

  // Apply CNPJ suggestion
  const applyCnpjSuggestion = () => {
    if (cnpjSuggestion) {
      setFormData(prev => ({
        ...prev,
        cnpj: cnpjSuggestion
      }));
      
      setCnpjSuggestion(null);
      
      // Clear CNPJ error
      setErrors(prev => ({
        ...prev,
        cnpj: null
      }));
    }
  };

  // Format phone number as user types
  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    
    // Remove all non-digits
    let digits = value.replace(/\D/g, '');
    
    // Limit to 11 digits (for cell phones with area code)
    digits = digits.slice(0, 11);
    
    // Format based on length
    let formatted = '';
    if (digits.length > 10) {
      // Cell phone format: (XX) XXXXX-XXXX
      formatted = digits.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
    } else if (digits.length > 6) {
      // Regular phone format: (XX) XXXX-XXXX
      formatted = digits.replace(/^(\d{2})(\d{4})(\d*).*/, '($1) $2-$3');
    } else if (digits.length > 2) {
      formatted = digits.replace(/^(\d{2})(\d*).*/, '($1) $2');
    } else {
      formatted = digits;
    }
    
    // Update the form data
    setFormData(prev => ({
      ...prev,
      [name]: formatted
    }));
  };
  
  // Format CEP as user types
  const handleCEPChange = (e) => {
    const { value } = e.target;
    
    // Remove all non-digits
    let digits = value.replace(/\D/g, '');
    
    // Limit to 8 digits
    digits = digits.slice(0, 8);
    
    // Format with mask: XXXXX-XXX
    let formatted = '';
    if (digits.length > 0) formatted += digits.slice(0, 5);
    if (digits.length > 5) formatted += '-' + digits.slice(5, 8);
    
    // Update the form data
    setFormData(prev => ({
      ...prev,
      cep: formatted
    }));
    
    // Clear error for this field when user types
    if (errors.cep) {
      setErrors(prev => ({
        ...prev,
        cep: null
      }));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const lookupCep = async () => {
    // Remove non-digits for the API call
    const cepDigits = formData.cep.replace(/\D/g, '');
    
    if (!cepDigits || cepDigits.length !== 8) {
      setErrors(prev => ({
        ...prev,
        cep: 'CEP inválido (deve conter 8 dígitos)'
      }));
      return;
    }

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cepDigits}/json/`);
      if (!response.ok) {
        throw new Error('Erro ao consultar CEP');
      }
      
      const data = await response.json();
      
      if (data.erro) {
        setErrors(prev => ({
          ...prev,
          cep: 'CEP não encontrado'
        }));
        return;
      }
      
      setFormData(prev => ({
        ...prev,
        endereco: data.logradouro || prev.endereco,
        bairro: data.bairro || prev.bairro,
        cidade: data.localidade || prev.cidade,
        estado: data.uf || prev.estado,
        pais: 'Brasil'
      }));
      
      // Clear CEP error if successful
      setErrors(prev => ({
        ...prev,
        cep: null
      }));
    } catch (err) {
      console.error('Erro ao buscar CEP:', err);
      setErrors(prev => ({
        ...prev,
        cep: 'Erro ao consultar CEP'
      }));
    }
  };

  // Function to validate CNPJ with verification digits
  const validateCNPJ = (cnpj) => {
    // Remove all non-digits
    const digits = cnpj.replace(/\D/g, '');
    
    // Check if it has 14 digits
    if (digits.length !== 14) {
      return false;
    }
    
    // Check if all digits are the same (invalidates CNPJ)
    if (/^(\d)\1{13}$/.test(digits)) {
      return false;
    }
    
    // Calculate first check digit
    let sum = 0;
    let weight = 5;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(digits.charAt(i)) * weight;
      weight = weight === 2 ? 9 : weight - 1;
    }
    
    let firstDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (firstDigit !== parseInt(digits.charAt(12))) {
      return false;
    }
    
    // Calculate second check digit
    sum = 0;
    weight = 6;
    for (let i = 0; i < 13; i++) {
      sum += parseInt(digits.charAt(i)) * weight;
      weight = weight === 2 ? 9 : weight - 1;
    }
    
    let secondDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    return secondDigit === parseInt(digits.charAt(13));
  };

  // Generate a valid CNPJ from an invalid one (keeps first 12 digits and corrects check digits)
  const generateValidCNPJ = (cnpj) => {
    // Remove all non-digits
    const digits = cnpj.replace(/\D/g, '');
    
    if (digits.length < 12) {
      return null; // Not enough digits to generate
    }
    
    // Take the first 12 digits
    const base = digits.slice(0, 12);
    
    // Calculate first verification digit
    let sum = 0;
    let weight = 5;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(base.charAt(i)) * weight;
      weight = weight === 2 ? 9 : weight - 1;
    }
    
    const firstDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    
    // Calculate second verification digit
    sum = 0;
    weight = 6;
    const withFirstDigit = base + firstDigit;
    
    for (let i = 0; i < 13; i++) {
      sum += parseInt(withFirstDigit.charAt(i)) * weight;
      weight = weight === 2 ? 9 : weight - 1;
    }
    
    const secondDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    
    // Format the CNPJ with the correct verification digits
    const correctedDigits = base + firstDigit + secondDigit;
    let formatted = '';
    if (correctedDigits.length > 0) formatted += correctedDigits.slice(0, 2);
    if (correctedDigits.length > 2) formatted += '.' + correctedDigits.slice(2, 5);
    if (correctedDigits.length > 5) formatted += '.' + correctedDigits.slice(5, 8);
    if (correctedDigits.length > 8) formatted += '/' + correctedDigits.slice(8, 12);
    if (correctedDigits.length > 12) formatted += '-' + correctedDigits.slice(12, 14);
    
    return formatted;
  };

  const validatePassword = (password) => {
    if (!password) return 'Senha é obrigatória';
    
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    
    if (password.length < minLength) {
      return 'A senha deve ter pelo menos 8 caracteres';
    }
    
    if (!hasUpperCase || !hasLowerCase) {
      return 'A senha deve conter letras maiúsculas e minúsculas';
    }
    
    if (!hasNumbers) {
      return 'A senha deve conter pelo menos um número';
    }
    
    if (!hasSpecialChar) {
      return 'A senha deve conter pelo menos um caractere especial';
    }
    
    return null;
  };

  const validateForm = () => {
    const newErrors = {};
    
    // Required fields
    if (!formData.razaoSocial.trim()) {
      newErrors.razaoSocial = 'Razão Social é obrigatória';
    }
    
    // CNPJ validation
    if (!formData.cnpj.trim()) {
      newErrors.cnpj = 'CNPJ é obrigatório';
    } else {
      // First check format
      const hasValidFormat = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/.test(formData.cnpj);
      
      if (!hasValidFormat) {
        newErrors.cnpj = 'Formato de CNPJ inválido';
      } else if (!validateCNPJ(formData.cnpj)) {
        newErrors.cnpj = 'CNPJ inválido (dígitos verificadores incorretos)';
        
        // Generate a suggestion
        const suggestion = generateValidCNPJ(formData.cnpj);
        if (suggestion && suggestion !== formData.cnpj) {
          setCnpjSuggestion(suggestion);
        }
      }
    }
    
    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = 'E-mail é obrigatório';
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = 'E-mail inválido';
    }
    
    // Password validation (only if creating new or if password is provided)
    if (!cliente || formData.password) {
      const passwordError = validatePassword(formData.password);
      if (passwordError) {
        newErrors.password = passwordError;
      }
      
      // Confirm password validation
      if (formData.password !== formData.confirmarSenha) {
        newErrors.confirmarSenha = 'As senhas não coincidem';
      }
    }
    
    // CEP validation (optional field)
    if (formData.cep && formData.cep.replace(/\D/g, '').length !== 8) {
      newErrors.cep = 'CEP inválido (deve conter 8 dígitos)';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {     
      // Remove confirmarSenha from the data sent to the server
      const { confirmarSenha, ...dataToSubmit } = formData;
      
      // If editing and password is empty, remove it from submission
      if (cliente && !dataToSubmit.password) {
        delete dataToSubmit.password;
      }
      
      onSubmit(dataToSubmit);
    }
  };

  return (
    <form className="cliente-form" onSubmit={handleSubmit} style={{ padding: '20px' }}>
      <div className="cliente-form-content" style={{
        maxHeight: 'calc(90vh - 200px)',
        overflowY: 'auto',
        paddingRight: '10px',
        marginBottom: '10px'
      }}>
        <div className="form-section">
        <h3>Dados da Empresa</h3>
        
        <div className="form-row">
          <div className="form-group" style={{ flex: 3 }}>
            <label htmlFor="razaoSocial">Razão Social *</label>
            <input
              type="text"
              id="razaoSocial"
              name="razaoSocial"
              value={formData.razaoSocial}
              onChange={handleChange}
              className={`form-control ${errors.razaoSocial ? 'is-invalid' : ''}`}
              placeholder="Razão Social da empresa"
            />
            {errors.razaoSocial && <div className="error-text">{errors.razaoSocial}</div>}
          </div>
          
          <div className="form-group" style={{ flex: 2 }}>
            <label htmlFor="nomeFantasia">Nome Fantasia</label>
            <input
              type="text"
              id="nomeFantasia"
              name="nomeFantasia"
              value={formData.nomeFantasia}
              onChange={handleChange}
              className="form-control"
              placeholder="Nome Fantasia (opcional)"
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="cnpj">CNPJ *</label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                id="cnpj"
                name="cnpj"
                value={formData.cnpj}
                onChange={handleCNPJChange}
                className={`form-control ${errors.cnpj ? 'is-invalid' : ''}`}
                placeholder="00.000.000/0000-00"
              />
              {cnpjSuggestion && (
                <div style={{ marginTop: '5px' }}>
                  <div className="suggestion-text">
                    CNPJ sugerido: <strong>{cnpjSuggestion}</strong>
                    <button 
                      type="button" 
                      onClick={applyCnpjSuggestion}
                      className="clientes-btn clientes-btn-sm clientes-btn-outline"
                      style={{ marginLeft: '10px' }}
                    >
                      Aplicar
                    </button>
                  </div>
                </div>
              )}
            </div>
            {errors.cnpj && <div className="error-text">{errors.cnpj}</div>}
          </div>
          
          <div className="form-group">
            <label htmlFor="nire">NIRE</label>
            <input
              type="text"
              id="nire"
              name="nire"
              value={formData.nire}
              onChange={handleChange}
              className="form-control"
              placeholder="NIRE"
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="telefone">Telefone</label>
            <input
              type="text"
              id="telefone"
              name="telefone"
              value={formData.telefone}
              onChange={handlePhoneChange}
              className="form-control"
              placeholder="(00) 0000-0000"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="celularWhatsApp">Celular/WhatsApp</label>
            <input
              type="text"
              id="celularWhatsApp"
              name="celularWhatsApp"
              value={formData.celularWhatsApp}
              onChange={handlePhoneChange}
              className="form-control"
              placeholder="(00) 00000-0000"
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group" style={{ flex: 2 }}>
            <label htmlFor="emailRF">Email do Responsável</label>
            <input
              type="email"
              id="emailRF"
              name="emailRF"
              value={formData.emailRF}
              onChange={handleChange}
              className="form-control"
              placeholder="email@responsavel.com.br"
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="telefoneResponsavel">Telefone do Responsável</label>
            <input
              type="text"
              id="telefoneResponsavel"
              name="telefoneResponsavel"
              value={formData.telefoneResponsavel}
              onChange={handlePhoneChange}
              className="form-control"
              placeholder="(00) 0000-0000"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="celularWhatsAppResponsavel">Celular/WhatsApp do Responsável</label>
            <input
              type="text"
              id="celularWhatsAppResponsavel"
              name="celularWhatsAppResponsavel"
              value={formData.celularWhatsAppResponsavel}
              onChange={handlePhoneChange}
              className="form-control"
              placeholder="(00) 00000-0000"
            />
          </div>
        </div>
      </div>
      
      <div className="form-section">
        <h3>Endereço</h3>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="cep">CEP</label>
            <div style={{ display: 'flex', gap: '5px' }}>
              <input
                type="text"
                id="cep"
                name="cep"
                value={formData.cep}
                onChange={handleCEPChange}
                className={`form-control ${errors.cep ? 'is-invalid' : ''}`}
                placeholder="00000-000"
              />
              <button 
                type="button" 
                className="clientes-btn clientes-btn-outline" 
                onClick={lookupCep}
                style={{ whiteSpace: 'nowrap' }}
              >
                Buscar
              </button>
            </div>
            {errors.cep && <div className="error-text">{errors.cep}</div>}
          </div>
          
          <div className="form-group" style={{ flex: 3 }}>
            <label htmlFor="endereco">Endereço</label>
            <input
              type="text"
              id="endereco"
              name="endereco"
              value={formData.endereco}
              onChange={handleChange}
              className="form-control"
              placeholder="Rua, Avenida, etc."
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group" style={{ flex: 1 }}>
            <label htmlFor="numero">Número</label>
            <input
              type="text"
              id="numero"
              name="numero"
              value={formData.numero}
              onChange={handleChange}
              className="form-control"
              placeholder="Nº"
            />
          </div>
          
          <div className="form-group" style={{ flex: 2 }}>
            <label htmlFor="complemento">Complemento</label>
            <input
              type="text"
              id="complemento"
              name="complemento"
              value={formData.complemento}
              onChange={handleChange}
              className="form-control"
              placeholder="Sala, Andar, etc."
            />
          </div>
        
          <div className="form-group" style={{ flex: 3 }}>
            <label htmlFor="bairro">Bairro</label>
            <input
              type="text"
              id="bairro"
              name="bairro"
              value={formData.bairro}
              onChange={handleChange}
              className="form-control"
              placeholder="Bairro"
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group" style={{ flex: 3 }}>
            <label htmlFor="cidade">Cidade</label>
            <input
              type="text"
              id="cidade"
              name="cidade"
              value={formData.cidade}
              onChange={handleChange}
              className="form-control"
              placeholder="Cidade"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="estado">Estado</label>
            <select
              id="estado"
              name="estado"
              value={formData.estado}
              onChange={handleChange}
              className="form-control"
            >
              <option value="">Selecione...</option>
              {estados.map(estado => (
                <option key={estado} value={estado}>{estado}</option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="pais">País</label>
            <input
              type="text"
              id="pais"
              name="pais"
              value={formData.pais}
              onChange={handleChange}
              className="form-control"
              placeholder="País"
            />
          </div>
        </div>
      </div>
      
      <div className="form-section">
        <h3>Responsável por Assinar Capa de Requerimento</h3>
        
        <div className="form-row">
          <div className="form-group" style={{ flex: 3 }}>
            <label htmlFor="nomeCompletoResponsavel">Nome Completo</label>
            <input
              type="text"
              id="nomeCompletoResponsavel"
              name="nomeCompletoResponsavel"
              value={formData.nomeCompletoResponsavel}
              onChange={handleChange}
              className="form-control"
              placeholder="Nome completo do responsável"
            />
          </div>
          
          <div className="form-group" style={{ flex: 2 }}>
            <label htmlFor="cargo">Cargo</label>
            <select
              id="cargo"
              name="cargo"
              value={formData.cargo}
              onChange={handleChange}
              className="form-control"
            >
              <option value="">Selecione o cargo...</option>
              {cargos.map(cargo => (
                <option key={cargo} value={cargo}>{cargo}</option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="dataNascimento">Data de Nascimento</label>
            <input
              type="date"
              id="dataNascimento"
              name="dataNascimento"
              value={formData.dataNascimento}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>
      </div>
      
      <div className="form-section">
        <h3>Assinante DBE</h3>
        
        <div className="form-row">
          <div className="form-group" style={{ flex: 3 }}>
            <label htmlFor="nomeCompletoAssinanteDBE">Nome Completo</label>
            <input
              type="text"
              id="nomeCompletoAssinanteDBE"
              name="nomeCompletoAssinanteDBE"
              value={formData.nomeCompletoAssinanteDBE}
              onChange={handleChange}
              className="form-control"
              placeholder="Nome completo do assinante DBE"
            />
          </div>
          
          <div className="form-group" style={{ flex: 2 }}>
            <label htmlFor="cargoAssinanteDBE">Cargo</label>
            <select
              id="cargoAssinanteDBE"
              name="cargoAssinanteDBE"
              value={formData.cargoAssinanteDBE}
              onChange={handleChange}
              className="form-control"
            >
              <option value="">Selecione o cargo...</option>
              {cargos.map(cargo => (
                <option key={cargo} value={cargo}>{cargo}</option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="dataNascimentoAssinanteDBE">Data de Nascimento</label>
            <input
              type="date"
              id="dataNascimentoAssinanteDBE"
              name="dataNascimentoAssinanteDBE"
              value={formData.dataNascimentoAssinanteDBE}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>
      </div>
      
      <div className="form-section">
        <h3>Informações de Acesso</h3>
        
        <div className="form-row">
          <div className="form-group" style={{ flex: 2 }}>
            <label htmlFor="email">E-mail de Login *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
              placeholder="email@empresa.com.br"
            />
            {errors.email && <div className="error-text">{errors.email}</div>}
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="password">Senha {cliente ? '(deixe em branco para manter a atual)' : '*'}</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                placeholder="********"
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer'
                }}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
            {errors.password && <div className="error-text">{errors.password}</div>}
            {!cliente && (
              <small className="text-muted">
                A senha deve ter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas, números e caracteres especiais.
              </small>
            )}
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmarSenha">Confirmar Senha {cliente ? '' : '*'}</label>
            <input
              type={showPassword ? "text" : "password"}
              id="confirmarSenha"
              name="confirmarSenha"
              value={formData.confirmarSenha}
              onChange={handleChange}
              className={`form-control ${errors.confirmarSenha ? 'is-invalid' : ''}`}
              placeholder="********"
            />
            {errors.confirmarSenha && <div className="error-text">{errors.confirmarSenha}</div>}
          </div>
        </div>
        </div>
      </div>
      
      <div className="modal-footer" style={{
        position: 'sticky',
        bottom: '0',
        backgroundColor: 'white',
        paddingTop: '15px',
        marginTop: '0'
      }}>
        <button type="button" className="clientes-btn clientes-btn-secondary" onClick={onCancel}>
          Cancelar
        </button>
        <button 
          type="submit" 
          className="clientes-btn clientes-btn-primary"
        >
          {cliente ? 'Atualizar' : 'Salvar'}
        </button>
      </div>
    </form>
  );
};

export default ClienteForm;